import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, Platform } from "react-native";
import AppTheme from "../../AppTheme";
import ManaTextInput from "../../common/ManaTextInput";
import Animation from "../LotieView";

export default function NameSelector({ data, slide, updateInfo = () => {} }) {
  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    if (animation) animation.play();
  }, [animation]);

  return (
    <View style={styles.container}>
      <Animation
        ref={(ref) => {
          setAnimation(ref);
        }}
        style={{
          height: "auto",
          width: 280,
        }}
        source={require("../../../../assets/animations/screen2.json")}
        loop={true}
      />

      <View
        style={{
          alignItems: "center",
          marginTop: -200,
        }}
      >
        <Text style={styles.title}>What should I call you?</Text>

        <ManaTextInput
          debounceDelay={700}
          disableBorder
          style={[
            styles.input,
            data[slide.name]?.length > 12 ? styles.inputSmall : {},
          ]}
          placeholderTextColor="#9C9EB9"
          name={slide.name}
          placeholder={slide.name}
          onTextChanged={(text) => updateInfo(slide.name, text)}
          value={data[slide.name] || ""}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    minHeight: 220,
    paddingTop: 30,
  },
  title: {
    zIndex: 10,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: "#2D3142",
  },
  input: {
    width: 257,
    maxHeight: 50,
    marginTop: 33,
    shadowOpacity: 0,
    textAlign: "center",
    
    borderBottomWidth: 1,
    borderBottomColor: "rgba(45, 49, 66, 0.3)",
    borderRadius: 0,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 32,
    lineHeight: 35,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    marginBottom: 40,
    elevation: 0,
  },
  inputSmall: {
    fontSize: 20,
    lineHeight: 22,
  },
});
